<template>
  <div class="profit-widget--content">
    <div class="profit-widget--data" v-if="!showPreloader">
      <div class="profit-widget--prev">
        <div>Доход предыдущий месяц</div>
        <div class="text-bold">{{ data.prev_month }}</div>
      </div>
      <div class="profit-widget--current">
        <div>Доход текущий месяц</div>
        <div class="text-bold">{{ data.current_month }}</div>
      </div>
    </div>
    <div class="profit-widget--preloader" v-if="showPreloader">
      <img :src="require('../../../assets/img/loader_6.svg')"  alt=""/>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import statisticsRepository from "../../../repositories/statistics";

export default {
  name: "ProfitWidget",
  components: {},
  data() {
    return {
      intervalProgress: false,
    };
  },
  props: {

  },
  watch: {

  },
  computed: {
    ...mapState({
      nextUpdate: state => state.journal_profit.nextUpdate,
      data: state => state.journal_profit.data,
    }),
    showPreloader(){
      return !this.data.prev_month && !this.data.current_month;
    }
  },
  methods: {
    getData(){
      let nowDate = new Date();
      if( this.nextUpdate < nowDate.getTime() ){
        statisticsRepository.journalProfit().then(resp => {
          this.$store.dispatch("addJournalProfit", resp.data);
        }).catch(() => {
          this.$store.dispatch("addBalance", []);
        });
      }
    },
  },
  created() {
    setTimeout(this.getData, 4500);
  },
};
</script>

<style scoped lang="less">
  .profit-widget--content{

    .profit-widget--data{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    flex-direction: row;

    .profit-widget--current{
      border-left: 1px solid gray;
      margin-left: 10px;
      padding-left: 10px;
    }
  }
}
.profit-widget--preloader{
  img{
    width: 15px;
  }
}
</style>
